export default __webpack_public_path__ + "static/media/1.8792feb3.png";